import { api } from "./apiBaseQuery";

export const selectionDatesServices: any = api.injectEndpoints({
  endpoints: (builder) => ({
    getRules: builder.mutation({
      query: (periodoId: number) => {
        return {
          url: `/Admins/Reglas?periodoId=${periodoId}`,
          method: "GET",
        };
      },
    }),
    getSelectionDates: builder.mutation({
      query: (anio: number) => {
        return {
          url: `/Admins/ProcesoMatriculacion?anio=${anio}`,
          method: "GET",
        };
      },
    }),
    createSelectionDate: builder.mutation({
      query: (body) => {
        return {
          url: `/Admins/ProcesoMatriculacion`,
          method: "POST",
          body,
        };
      },
    }),
    updateSelectionDate: builder.mutation({
      query: (body) => {
        const id = body.id;
        delete body.id;
        return {
          url: `/Admins/ProcesoMatriculacion/${id}`,
          method: "PUT",
          body,
        };
      },
    }),
    updateSelectionState: builder.mutation({
      query: (body) => {
        const id = body.id;
        delete body.id;
        return {
          url: `/Admins/ProcesoMatriculacion/Estado/${id}`,
          method: "PUT",
          body,
        };
      },
    }),
  }),
});

export const {
  useGetSelectionDatesMutation,
  useGetRulesMutation,
  useCreateSelectionDateMutation,
  useUpdateSelectionDateMutation,
  useUpdateSelectionStateMutation,
} = selectionDatesServices;
